import React, { Component } from 'react'
import request from "../../../lib/requester";
import _, { toNumber } from "lodash";
import { Link } from "react-router-dom";
import moment from "moment";
import DatePicker from "react-datepicker";
import { Loader } from "react-overlay-loader";

class ClaimDetailCHD extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      General_SkpNumber: '',
      General_ProgramNumber: '',
      General_Principal: '',
      General_ReffNumber: '',
      General_ProgramType: '',
      General_ProgramDescription: '',
      General_BudgetType: '',
      General_AssignmentType: '',
      General_ProgramSubmittedDate: '',
      General_StartDate: '',
      General_EndDate: '',
      General_ClaimExpDate: '',
      General_Budget: '',
      General_BudgetRemaining: '',
      General_SalesTarget: '',
      General_CustomerPPHType: '',
      General_PPhRate: '',
      General_PrincipalCode: '',
      Customer_Id: '',
      Customer_Name: '',
      Customer_NPWP: '',
      Customer_NPWPName: '',
      Customer_NPWPAddress: '',
      Customer_BankName: '',
      Customer_BankAccountNo: '',
      Customer_BankAccountOwner: '',
      Customer_PKP_Badan: '',
      Customer_Potong_Pajak: '',
      Claim_PaymentMethod: 'TRF',
      Claim_Activity: '',
      Claim_CostCenter: '',
      Claim_DPP: '',
      Claim_PPh: '',
      Claim_PPhRate: '',
      Claim_PPn: '',
      Claim_TaxNo: '',
      Claim_TotalAmount: '',
      Claim_SKB: '',
      Claim_CustomerReceipt: '',
      Claim_TotalSales: '',
      Claim_TaxDate: '',
      Claim_SKBNumber: '',
      Claim_Source_DWH: 'N',
      Claim_PPh_Type: '',
      Claim_SKB_Start_Date: '',
      Claim_SKB_End_Date: '',
      Claim_Bukpot: 0,
      Claim_Nett: 0,
      Claim_ClaimNumber: '',
      Claim_Period_Type: '',
      Claim_Period_Month: '',
      Claim_Period_Year: '',
      Claim_Rejected_By: '',
      Claim_Old_PPh_type: '',
      Attachment_Display: 'N',
      Attachment_Jml_Display: '',
      Attachment_Data: 'N',
      Attachment_Jml_Data: '',
      Updated_By: '',
      Program_Customer_ID: '',
      Show_Display_Upload: false,
      Attachment: [],
      Product_List: [],
      lovActivity: [],
      lovCostCenter: [],
      lovPPhType: [],
      lovPackage: [],
      Document_List: [],
      Document_Selected: [],
      fileRequired: { filename: '', path: '' },
      fileSKB: { filename: '', path: '' },
      error: [],
      success: '',
      user: JSON.parse(window.localStorage.getItem('is_user')),
      ppnrate: 10
    }
  }

  componentDidMount = () => {
    this.getClaimData()
    this.getMasterData()
  }

  getMasterData = () => {
    let url = '/api/traces_chd/v1/program/data-master'
    request.getCHD(url, {
      success: function (response) {
        let { ProgramPPhType } = response.data.data
        this.setState({
          lovPPhType: ProgramPPhType
        })
      }.bind(this),
      error: function (e) {
        console.log(e.message)
      }
    })
  }

  renderLovPPhType = () => {
    return (
      <select className="form-control col-md-8" name="Claim_PPh_Type" disabled={this.state.Claim_Old_PPh_type} value={this.state.Claim_PPh_Type} onChange={this.handleChangeInput.bind(this)}>
        <option value="">- Select PPh Type -</option>
        {
          this.state.lovPPhType.map((item, index) => (
            <option value={item.pph_type} key={index}>{item.pph_type}</option>
          ))
        }
      </select>
    )
  }

  showNotification = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fa fa-check" /> {this.state.success}
        </div>
      );
    } else if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}><i className="fas fa-exclamation-triangle" /> {item}</li>;
            })}
          </ul>
        </div>
      );
    }
  }

  getClaimData = () => {
    let url = '/api/traces_chd/v1/claim/data-claim-by-id'
    let { id } = this.props.match.params;
    let param = {
      claim_id: id
    }

    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function (response) {
        let { Program, Document, Claim, Product, Activity, CostCenter, Package } = response.data.data

        // Rebuild Product
        let NewProduct = Product.map((item, index) => {
          item.item_actual = '0'
          return item
        })

        // Rebuild Document
        let NewDocument = []
        Document.forEach((item, index) => {
          NewDocument.push({ documentId: item.document_id })
        })
        this.setState({
          loading: false,
          Product_List: NewProduct,
          lovActivity: Activity,
          lovCostCenter: CostCenter,
          lovPackage: Package,
          Document_List: Document,
          Document_Selected: NewDocument
        })

        this.setDefaultValue(Program)
        this.setDefaultValueClaim(Claim)

        if (Claim.rejected_by === 'CASHIER') {
          this.reCalculate(Claim)
        } else {
          // Get Latest Reward
          this.calculateTotalClaim()
        }
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false })
        console.log(e.message)
      }.bind(this)
    })
  }

  reCalculate = (claim) => {
    this.setState({
      Claim_PPh: 0,
      Claim_PPhRate: 0,
      Claim_PPh_Type: '',
      Claim_Nett: claim.pph_type?.includes("PPh21") ? this.thousandSeparator(claim.dpp) : this.thousandSeparator(claim.nett_claim),
      Claim_TotalAmount: this.thousandSeparator(claim.total),
      Claim_PPn: claim.ppn ? this.thousandSeparator(claim.ppn) : '0'
    })

    setTimeout(() => {
      if(claim.pph_type?.includes("PPh21")){
        this.calculateAmount()
      }
    }, 200)
  }

  setDefaultValueClaim = (claim) => {
    this.setState({
      Program_Customer_ID: claim.program_customer_id,
      Claim_ClaimNumber: claim.claim_number || '',
      Claim_CostCenter: claim.ccid ? claim.ccid.toString() : '',
      Claim_Activity: claim.activity_id || '',
      Claim_DPP: claim.dpp ? this.thousandSeparator(claim.dpp) : '',
      Claim_PPh: claim.pph ? this.thousandSeparator(claim.pph) : '0',
      Claim_PPhRate: claim.pph_rate ? claim.pph_rate.toString() : '0',
      Claim_PPh_Type: claim.pph_type,
      Claim_PPn: claim.ppn ? this.thousandSeparator(claim.ppn) : '0',
      Claim_TaxDate: claim.tax_date ? new Date(claim.tax_date) : '',
      Claim_TaxNo: claim.tax_no || '',
      Claim_SKB: claim.skb || 'N',
      Claim_SKBNumber: claim.skb_number || '',
      Claim_Nett: this.thousandSeparator(claim.nett_claim || '0'),
      Claim_SKB_End_Date: claim.start_date_skb ? new Date(claim.start_date_skb) : '',
      Claim_SKB_Start_Date: claim.end_date_skb ? new Date(claim.end_date_skb) : '',
      Claim_CustomerReceipt: claim.cust_receipt_no || '',
      Claim_Bukpot: claim.bukpot_amount || 0,
      Claim_TotalAmount: claim.total ? this.thousandSeparator(claim.total) : 0,
      Claim_Rejected_By: claim.rejected_by,
      Claim_Old_PPh_type: claim.old_pph_type,
      Updated_By: claim.user_updated_by || '',
      Attachment_Jml_Display: claim.jml_display,
      Attachment_Jml_Data: claim.jml_additional_data,
      fileSKB: { filename: claim.doc_skb_filename || '', path: claim.doc_skb_path || '' },
      fileRequired: { filename: claim.doc_mandatory_filename || '', path: claim.doc_mandatory_path || '' },
      Claim_Reason_Reject: claim.reason_reject && claim.reason_reject.length > 0 ? claim.reason_reject : claim.payment_reject_reason
    })
  }

  setDefaultValue = (data) => {
    this.setState({
      General_PrincipalCode: data.org_initial,
      General_SkpNumber: data.skp_number,
      General_ProgramNumber: data.program_number,
      General_Principal: data.org_name,
      General_ReffNumber: data.ref_number,
      General_ProgramType: data.program_name,
      General_ProgramDescription: data.description,
      General_BudgetType: data.budget_type,
      General_AssignmentType: data.customer_assignment_type,
      General_ProgramSubmittedDate: data.creation_date ? moment(data.creation_date).format('DD-MMM-YYYY') : '',
      General_StartDate: data.start_date ? moment(data.start_date).format('DD-MMM-YYYY') : '',
      General_EndDate: data.end_date ? moment(data.end_date).format('DD-MMM-YYYY') : '',
      General_ClaimExpDate: data.claim_exp_date ? moment(data.claim_exp_date).format('DD-MMM-YYYY') : '',
      General_Budget: data.budget ? this.thousandSeparator(data.budget) : '0',
      General_BudgetRemaining: data.sisa_budget || 0,
      General_SalesTarget: data.sales_target ? this.thousandSeparator(data.sales_target) : '0',
      General_CustomerPPHType: data.pph_type,
      General_PPhRate: data.pph_rate,
      General_Branch_Code: data.branch_code,
      Customer_Id: data.customer_id,
      Customer_Name: data.customer_name || '',
      Customer_NPWP: data.npwp || '',
      Customer_NPWPAddress: data.npwp_address || '',
      Customer_NPWPName: data.npwp_name || '',
      Customer_BankName: data.bank_name || '',
      Customer_BankAccountNo: data.bank_account_no || '',
      Customer_BankAccountOwner: data.bank_account_owner || '',
      Customer_PKP_Badan: data.pkp_badan,
      Customer_Potong_Pajak: data.potong_pajak,
      Claim_PPhRate: data.pph_rate,
      Attachment_Display: data.display,
      Attachment_Data: data.additional_data,
      Attachment_Jml_Display: data.jml_display,
      Claim_Source_DWH: data.source_dwh,
      Claim_Package: data.package,
      Claim_Period_Year: data.start_date ? moment(data.start_date).format('YYYY') : '',
      Claim_Period_Type: 'Q',
      Claim_Period_Month: data.start_date ? moment(data.start_date).quarter() : 0
    })
  }

  renderGeneralInfo = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          {this.showNotification()}
          <div className="card">
            <div className="card-header bg-light">
              <a className="text-decoration-none text-dark font-size-title" data-toggle="collapse" href="#multiCollapseExample2" role="button" aria-expanded="true" aria-controls="multiCollapseExample2">General Info <i className="fas fa-chevron-down font-size-small text-muted" /></a>
            </div>
            <div className="multi-collapse collapse" id="multiCollapseExample2">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">SKP Number</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_SkpNumber} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Program Number</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_ProgramNumber} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Principal</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_Principal} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Reff Number / SKP</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_ReffNumber} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Program Type</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_ProgramType} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Program Description</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_ProgramDescription} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Budget Type</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_BudgetType} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Customer Assignment Type</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_AssignmentType} />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Start Date</label>
                      <input type="text" className="form-control col-md-3" disabled={true} value={this.state.General_StartDate} />
                      <label className="col-md-2 mt-1">End Date</label>
                      <input type="text" className="form-control col-md-3" disabled={true} value={this.state.General_EndDate} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Claim Exp Date</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_ClaimExpDate} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Budget</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_Budget} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Budget Remaining</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_BudgetRemaining} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Sales Target</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_SalesTarget} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Customer PPH Type</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_CustomerPPHType} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">PPh Rate (%)</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_PPhRate} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Program Submitted Date</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_ProgramSubmittedDate} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderCustomerInfo = () => {
    return (
      <div className="card">
        <div className="card-header bg-light">
          <a className="text-decoration-none text-dark font-size-title" data-toggle="collapse" href="#multiCollapseExample1" role="button" aria-expanded="false" aria-controls="multiCollapseExample1">Customer Info <i className="fas fa-chevron-down font-size-small text-muted" /></a>
        </div>
        <div className="multi-collapse show" id="multiCollapseExample1">
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-md-4 mt-1">Customer</label>
                  <input type="text" className="form-control col-md-8" disabled={true} value={this.state.Customer_Name} />
                </div>
                <div className="form-group row">
                  <label className="col-md-4 mt-1">NPWP Name</label>
                  <input type="text" className="form-control col-md-8" disabled={true} value={this.state.Customer_NPWPName} />
                </div>
                <div className="form-group row">
                  <label className="col-md-4 mt-1">NPWP Address</label>
                  <input type="text" className="form-control col-md-8" disabled={true} value={this.state.Customer_NPWPAddress} />
                </div>
                <div className="form-group row">
                  <label className="col-md-4 mt-1">NPWP / NIK</label>
                  <input type="text" className="form-control col-md-8" disabled={true} value={this.state.Customer_NPWP} />
                </div>
                <div hidden className="form-group row">
                  <label className="col-md-4 mt-1">Potong Pajak</label>
                  <div className="col-md-8">
                    <div className="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="customRadioInline1" name="customRadioInline1" className="custom-control-input" disabled={true} value="Y" checked={this.state.Customer_Potong_Pajak === 'Y' ? true : false} />
                      <label className="custom-control-label" htmlFor="customRadioInline1">Ya</label>
                    </div>
                    <div className="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="customRadioInline2" name="customRadioInline2" className="custom-control-input" disabled={true} value="N" checked={(this.state.Customer_Potong_Pajak === 'N' || this.state.Customer_Potong_Pajak === null) ? true : false} />
                      <label className="custom-control-label" htmlFor="customRadioInline2">Tidak</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-md-4 mt-1">PKP Badan</label>
                  <div className="col-md-8">
                    <div className="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="customRadioInline3" name="customRadioInline3" className="custom-control-input" disabled={true} value="Y" checked={(this.state.Customer_PKP_Badan === 'Y') ? true : false} />
                      <label className="custom-control-label" htmlFor="customRadioInline1">Ya</label>
                    </div>
                    <div className="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="customRadioInline4" name="customRadioInline4" className="custom-control-input" disabled={true} value="N" checked={(this.state.Customer_PKP_Badan === 'N' || this.state.Customer_PKP_Badan === null) ? true : false} />
                      <label className="custom-control-label" htmlFor="customRadioInline2">Tidak</label>
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-md-4 mt-1">Bank Name</label>
                  <input type="text" className="form-control col-md-8" disabled={true} value={this.state.Customer_BankName} />
                </div>
                <div className="form-group row">
                  <label className="col-md-4 mt-1">Bank Account No</label>
                  <input type="text" className="form-control col-md-8" disabled={true} value={this.state.Customer_BankAccountNo} />
                </div>
                <div className="form-group row">
                  <label className="col-md-4 mt-1">Bank Account Owner</label>
                  <input type="text" className="form-control col-md-8" disabled={true} value={this.state.Customer_BankAccountOwner} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  handleChangeInput = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    if (name === "Claim_PPh" || name === "Claim_PPn" || name === "Claim_DPP") {
      value = this.thousandSeparator(value);
    } else if (name === "Claim_PPhRate") {
      value = value.replace(/[^0-9.]/g, "").replace(/\./g, "");
      if (parseInt(value) > 100) value = 100;
      if (parseInt(value) < 0) value = 0;
    }

    this.setState({ [name]: value });
    if (name === "Claim_PPh" || name === "Claim_PPn" || name === "Claim_PPhRate") {
      let app = this;
      if (name === "Claim_DPP") {
        // let ppn = this.thousandSeparator(parseInt(this.removeSeparator(value)) / 10);

        let ppn = this.thousandSeparator(
          (parseInt(this.removeSeparator(value)) * this.state.ppnrate) / 100
        );

        app.setState({ Claim_PPn: ppn });
        window.setTimeout(() => {
          app.countPPH();
        }, 100);
      } else if (name === "Claim_PPhRate") {
        window.setTimeout(() => {
          app.countPPH();
        }, 100);
      }
      window.setTimeout(() => {
        app.calculateAmount();
        app.forceUpdate();
      }, 100);
    }

    if (name === 'Claim_PPh_Type') {
      let find = _.find(this.state.lovPPhType, function(o) {
        return o.pph_type === value
      })
      if (find) {
        this.setState({ Claim_PPhRate: find.pph_rate })
        let app = this
        window.setTimeout(function() {
         app.calculateTotalClaim()
        }, 200)
      }
   }
  };

  renderSKBAttachment = () => {
    if (this.state.fileSKB.filename && this.state.fileSKB.filename.length > 0) {
      return (
        <span className="mt-1">
          <Link to={{ pathname: this.state.fileSKB.path }} target="_blank">
            <i className="fa fa-file text-danger" />&nbsp; {this.state.fileSKB.filename}
          </Link>&nbsp;
          <button type="button" className="ml-1 btn btn-danger rounded-circle" onClick={this.handleRemoveFileSKB.bind(this)}><i className="fa fa-trash" /></button>
        </span>
      )
    } else {
      if (this.state.Claim_SKB === 'Y') {
        return (
          <input type="file" data-type="SKB" onChange={this.handleUploadSingle.bind(this)} />
        )
      }
    }
  }

  handleClickSKB = (e) => {
    let value = e.target.value;
    let isChecked = e.target.checked;
    if (isChecked) {
      let find = _.find(this.state.lovPPhType, function (o) {
        return o.pph_type === 'PPh23_0%';
      });
      if (find) {
        this.setState({ Claim_SKB: value, Claim_PPh_Type: 'PPh23_0%', Claim_PPhRate: find.pph_rate });
      }
    } else {
      this.setState({
        Claim_SKB: "N",
        Claim_SKB_Start_Date: '',
        Claim_SKB_End_Date: '',
        Claim_PPh_Type: '',
        Claim_PPhRate: 0
      });
      this.countPPH();
    }
    window.setTimeout(() => {
      this.calculateTotalClaim();
    }, 200);
    // window.setTimeout(() => {
    //   app.calculateAmount();
    // }, 200);
    // let value = e.target.value;
    // let isChecked = e.target.checked;
    // let app = this;

    // let { fileSKB } = this.state
    // if (isChecked) {
    //   this.setState({ Claim_SKB: value, Claim_PPh: 0 });
    // } else {
    //   fileSKB.filename = ''
    //   fileSKB.path = ''
    //   this.setState({ Claim_SKB: "N", Claim_SKBNumber: "" });
    //   this.setState(fileSKB)
    //   this.countPPH();
    // }
    // window.setTimeout(() => {
    //   app.calculateAmount();
    // }, 100);
  }

  handleRemoveFileSKB = () => {
    let { fileSKB } = this.state
    fileSKB.filename = ''
    fileSKB.path = ''

    this.setState(fileSKB)
  }

  renderSKBNumber = () => {
    if (this.state.Claim_SKB === "Y") {
      return (
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">SKB Number</label>
          <input
            type="text"
            autoComplete="off"
            className="form-control col-md-8"
            id="inputEmail3"
            name="Claim_SKBNumber"
            placeholder=""
            onChange={this.handleChangeInput.bind(this)}
            value={this.state.Claim_SKBNumber}
          />
        </div>
      );
    }
  };

  handleUploadSingle = (e) => {
    if (e.target.files.length === 0) {
      return false;
    }

    let files = e.target.files[0];
    let doctype = e.target.dataset.type;
    // validation
    let filename = files.name;
    var fileExt = filename.split(".").pop();
    var allowedFile = ["jpg", "png", "jpeg", "gif", "doc", "docx", "xls", "xlsx", "csv", "pdf"];
    if (allowedFile.indexOf(fileExt) < 0) {
      this.setState({ error: ["File extension not allowed"] });
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      return false;
    }

    const data = new FormData();
    data.append("myFile", files, files.name);
    this.setState({ loading: true });
    request.postnobodyCHD("/api/traces_chd/v1/util/upload-file", data, {
      success: function (response) {
        let data = response.data;

        if (doctype === "SKB") {
          let { fileSKB } = this.state;
          fileSKB.filename = data.filename;
          fileSKB.path = data.fullurl;
          this.setState(fileSKB);
        } else if (doctype === 'REQUIRED') {
          let { fileRequired } = this.state;
          fileRequired.filename = data.filename;
          fileRequired.path = data.fullurl;
          this.setState(fileRequired);
        }
        this.setState({ loading: false });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
        console.log(e.message)
      }.bind(this),
    });
  };

  countPPH = () => {
    let { Claim_DPP, Claim_PPhRate } = this.state;
    let pph = this.thousandSeparator((parseInt(Claim_PPhRate || 0) / 100) * parseInt(this.removeSeparator(Claim_DPP)));
    this.setState({ Claim_PPh: pph });
  };

  calculateAmount = () => {
    let { Claim_DPP, Claim_PPn, Claim_PPh, Claim_TotalAmount } = this.state;
    let totalAmount = (parseFloat(this.removeSeparator(Claim_DPP)) || 0) + (parseFloat(this.removeSeparator(Claim_PPn)) || 0) - (parseFloat(this.removeSeparator(Claim_PPh)) || 0);
    totalAmount = Math.round(totalAmount); // ilham, menambahkan round
    this.setState({
      // Claim_TotalAmount: this.thousandSeparator(totalAmount),
      Claim_PPn: this.thousandSeparator(Claim_PPn),
    });
  };

  handleTaxDate = (date) => {
    console.log(date)
    this.setState({ Claim_TaxDate: date })
  }

  renderClaimInfo = () => {
    return (
      <div className="card">
        <div className="card-header font-size-title bg-light">Claim Info</div>

        <div className="card-body">
          <div className="row">{this.renderPeriod()}</div>
          <h5>Attachment</h5>
          <div className="row">
            <div className="col-md-6">
              {this.renderDocumentV2()}
              <div className="row mt-2">
                <div className="col-md-12">
                  {this.renderUploadSingle("REQUIRED")}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                {this.renderJumlahDisplay()}
                {this.renderAdditionalData()}
              </div>
              <div className="row">
                <div className="col-md-12">{this.renderButtonCalculate()}</div>
              </div>
            </div>
          </div>
          <hr />
          <div className='row'>
            <div className='col-md-6'>
              <div className="form-group row">
                <label className="col-md-4 mt-1">Package</label>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control col-md-8"
                  disabled={true}
                  name="Claim_Package"
                  value={this.state.Claim_Package}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-md-4 mt-1 col-form-label">
                  Payment Method
                </label>
                <div className="col-sm-8 mt-2">
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="Claim_PaymentMethod"
                      value="TRF"
                      checked={true}
                    />{" "}
                    Transfer
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-md-4 mt-1">Activity</label>
                {this.renderLovActivity()}
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">Reward Value</label>
                {this.renderInputDPP()}
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">Tax No</label>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control col-md-8"
                  name="Claim_TaxNo"
                  disabled={false}
                  value={this.state.Claim_TaxNo}
                  onChange={this.handleChangeInput.bind(this)}
                />
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">PPh Type</label>
                {this.renderLovPPhType()}
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">PPh</label>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control col-md-8"
                  disabled={true}
                  name="Claim_PPh"
                  onChange={this.handleChangeInput.bind(this)}
                  value={this.state.Claim_PPh}
                />
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">Nett Claim</label>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control col-md-8"
                  disabled={true}
                  name="Claim_Nett"
                  value={this.state.Claim_Nett}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-md-4 mt-1">Cost Center</label>
                {this.renderLovCostCenter()}
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">PPN Rate (%)</label>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control col-md-8"
                  disabled={false}
                  name="Claim_PPn"
                  onChange={this.handleChangeInput.bind(this)}
                  value={this.state.ppnrate}
                />
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">PPN</label>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control col-md-8"
                  disabled={false}
                  name="Claim_PPn"
                  onChange={this.handleChangeInput.bind(this)}
                  value={this.state.Claim_PPn}
                />
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">Tax Date</label>
                <DatePicker
                  selected={this.state.Claim_TaxDate}
                  dateFormat="d-MMM-yyyy"
                  className="form-control col-md-8"
                  popperPlacement="top-end"
                  onChange={this.handleTaxDate}
                />
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">PPh Rate (%)</label>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control col-md-8"
                  disabled={true}
                  name="Claim_PPhRate"
                  onChange={this.handleChangeInput.bind(this)}
                  value={this.state.Claim_PPhRate}
                />
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">Total Claim (DPP)</label>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control col-md-8"
                  disabled={true}
                  name="Claim_TotalAmount"
                  value={this.state.Claim_TotalAmount}
                />
              </div>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-md-4 mt-1">SKB</label>
                <div className="col-sm-1 mt-2">
                  <div className="form-check form-check-inline">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      value="Y"
                      disabled={this.state.Claim_Rejected_By === 'CASHIER'}
                      checked={this.state.Claim_SKB === "Y" ? true : false}
                      onChange={this.handleClickSKB.bind(this)}
                    />
                  </div>
                </div>
                {this.renderSKBAttachment()}
              </div>
              {this.renderSKBPeriod()}
            </div>
            <div className="col-md-6">{this.renderSKBNumber()}</div>
          </div>
        </div>
      </div>
    );
  }

  renderSKBPeriod = () => {
    if (this.state.Claim_SKB === 'Y') {
      return (
        <div className="form-group row">
          <label className="col-md-4 mt-1">Start Date</label>
          <div className="col-md-3 p-0">
            <DatePicker
              selected={this.state.Claim_SKB_Start_Date}
              dateFormat="d-MMM-yyyy"
              className="form-control"
              popperPlacement="top-end"
              onChange={this.handleSKBDateStart}
            />
          </div>
          <label className="col-md-2 mt-1">End Date</label>
          <div className="col-md-3 p-0">
            <DatePicker
              selected={this.state.Claim_SKB_End_Date}
              dateFormat="d-MMM-yyyy"
              className="form-control"
              popperPlacement="top-end"
              onChange={this.handleSKBDateEnd}
            />
          </div>
        </div >
      )
    }
  }

  handleSKBDateStart = (date) => {
    let {Claim_DPP} = this.state
    this.setState({ Claim_SKB_Start_Date: date })

    let app = this
    console.log(Claim_DPP)
    if (parseInt(this.removeSeparator(Claim_DPP || 0)) > 0) {
      window.setTimeout(() => {
        app.calculateTotalClaim()
      }, 200)
    }
  }

  handleSKBDateEnd = (date) => {
    let {Claim_DPP} = this.state
    this.setState({ Claim_SKB_End_Date: date })

    let app = this
    console.log(Claim_DPP)
    if (parseInt(this.removeSeparator(Claim_DPP || 0)) > 0) {
      window.setTimeout(() => {
        app.calculateTotalClaim()
      }, 200)
    }
  }

  renderLovActivity = () => {
    return (
      <select className="form-control col-md-8" name="Claim_Activity" value={this.state.Claim_Activity} onChange={this.handleChangeInput.bind(this)}>
        <option value="">- Select Activty Program -</option>
        {
          this.state.lovActivity.map((item, index) => (
            <option key={index} value={item.activity_id}>{item.activity_name}</option>
          ))
        }
      </select>
    )
  }

  renderLovCostCenter = () => {
    return (
      <select className="form-control col-md-8" name="Claim_CostCenter" value={this.state.Claim_CostCenter} onChange={this.handleChangeInput.bind(this)}>
        <option value="">- Select Cost Center -</option>
        {
          this.state.lovCostCenter.map((item, index) => (
            <option key={index} value={item.cc_id}>{item.cost_center}</option>
          ))
        }
      </select>
    )
  }

  renderProduct = () => {
    return (
      <div className="card">
        <div className="card-header font-size-title bg-light">
          <a className="text-decoration-none text-dark font-size-title" data-toggle="collapse" href="#multiCollapseExample5" role="button" aria-expanded="true" aria-controls="multiCollapseExample2">Product <i className="fas fa-chevron-down font-size-small text-muted" /></a>
        </div>
        <div className="multi-collapse collapse" id="multiCollapseExample5">
          <div className="card-body">
            <div className="row">
              <div className="col-md-6 font-weight-bold">Product Description</div>
              <div className="col-md-3 font-weight-bold">Budget</div>
            </div>
            {this.renderProductDetail()}
          </div>
        </div>
      </div>
    )
  }

  renderProductDetail = () => {
    return this.state.Product_List.map((item, index) => (
      <div key={index} className="row mt-2">
        <div className="col-md-6"><input type="text" className="form-control" value={item.item_description} disabled /></div>
        <div className="col-md-3"><input type="text" className="form-control" value={this.thousandSeparator(item.item_budget)} disabled /></div>
      </div>
    ))
  }

  handleChangeActual = (index, e) => {
    let value = e.target.value
    let { Product_List } = this.state

    Product_List[index].item_actual = this.thousandSeparator(value)
    this.setState(Product_List)
  }

  thousandSeparator = (value) => {
    if (value.length === 0) return

    value = value.toString().replace(/,/g, "").replace(/[^0-9.]/g, "");
    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  removeSeparator = (value) => {
    if (!value || value.length === 0) {
      return
    }
    value = value.toString().replace(/,/g, "").replace(/[^0-9.]/g, "");
    return value;
  };

  handleClickDocument = (e) => {
    let is_checked = e.target.checked;
    let docId = e.target.value;
    let { Document_Selected } = this.state;
    if (is_checked) {
      Document_Selected.push({ documentId: docId });
    } else {
      let getIndex = _.findIndex(Document_Selected, function (o) {
        return parseInt(o.program_doc_id) === parseInt(docId);
      });
      Document_Selected.splice(getIndex, 1);
    }
    this.setState(Document_Selected);
  }

  renderDocumentV2 = () => {
    let { fileRequired } = this.state
    if (fileRequired.path.length === 0) {
      return this.state.Document_List.map((item, index) => (
        <div className="row">
          <div className="col-md-6" key={index}>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value={item.program_doc_id}
                onClick={this.handleClickDocument.bind(this)}
                id="defaultCheck1"
              />
              <label className="form-check-label" htmlFor="defaultCheck1">
                {item.document_name}
              </label>
            </div>
          </div>
        </div>
      ))
    } else {
      return this.state.Document_List.map((item, index) => (
        <div className="row">
          <div className="col-md-6" key={index}>
            <div className="">
              <label className="form-check-label" htmlFor="defaultCheck1">
                <i className="fa fa-check text-success" />&nbsp;{item.document_name}
              </label>
            </div>
          </div>
        </div>
      ))
    }
  }

  handleRemoveFile = () => {
    let { fileRequired } = this.state
    fileRequired.filename = ''
    fileRequired.path = ''
    this.setState(fileRequired)
    this.setState({ Document_Selected: [] })
  }

  renderDocumentDisplay = () => {
    let { fileDisplay } = this.state
    if (fileDisplay.path.length === 0) {
      return (
        <div className="row">
          <div className="col-md-6">
            <div className="form-check">
              <input className="form-check-input" type="checkbox" value={1} name="Display_Attachment" onClick={this.handleClickDisplay.bind(this)} id="defaultCheck1" />
              <label className="form-check-label" htmlFor="defaultCheck1">Foto Display</label>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div className="row">
          <div className="col-md-6">
            <div className="">
              <label className="form-check-label" htmlFor="defaultCheck1">Foto Display</label>
            </div>
          </div>
        </div>
      )
    }
  }

  handleClickDisplay = (e) => {
    let is_checked = e.target.checked;
    let { fileDisplay } = this.state
    if (is_checked) {
      this.setState({ Show_Display_Upload: true })
    } else {
      fileDisplay.filename = ''
      fileDisplay.path = ''
      this.setState({ Show_Display_Upload: false })
      this.setState(fileDisplay)
    }
  }

  renderUploadSingle = (type) => {
    if (type === 'REQUIRED') {
      if (this.state.fileRequired.path && this.state.fileRequired.path.length > 0) {
        return (
          <div className="row">
            <div className="col-md-12">
              <div className="form-group row">
                <label className="col-md-4 mt-1">Upload Files</label>
                <div className="col-md-8">
                  <a target='_blank' href={this.state.fileRequired.path}>{this.state.fileRequired.filename}</a> &nbsp; <button className="btn btn-danger rounded-circle" onClick={this.handleRemoveFile.bind(this)}><i className="fa fa-trash" /></button>
                </div>
              </div>
            </div>
          </div>
        )
      } else {
        if (this.state.Document_Selected.length === this.state.Document_List.length) {
          return (
            <div className="row">
              <div className="col-md-12">
                <div className="form-group row">
                  <label className="col-md-4 mt-1">Upload Files</label>
                  <input type="file" className="form-control col-md-8" data-type="REQUIRED" onChange={this.handleUploadSingle.bind(this)} />
                </div>
              </div>
            </div>
          )
        }
      }
    }
  }

  handleCalculateDPP = () => {
    let { lovPackage } = this.state
    let app = this
    let currentPackage = _.find(lovPackage, function (o) {
      return o.package_name === app.state.Claim_Package
    })
    let requiredJmlDisplay = parseInt(currentPackage.jml_display) || 0

    this.setState({ error: [] })
    if (this.state.Attachment_Display === 'Y') {
      if (parseInt(this.state.Attachment_Jml_Display || 0) < requiredJmlDisplay) {
        this.setState({ error: ['Jumlah display kurang dari persyaratan (' + requiredJmlDisplay + ')'] })
        window.scrollTo(0, 0)
        return false
      }
    }

    this.calculateTotalClaim()
  }

  renderButtonCalculate = () => {
    if (this.state.Claim_Source_DWH === 'Y') {
      return (
        <span>
          <button type="button" className="btn btn-success btn-block" onClick={this.handleCalculateDPP.bind(this)} disabled><i className="fa fa-gift" /> GET REWARDS</button>
        </span>
      )
    }
  }

  renderJumlahDisplay = () => {
    if (this.state.Attachment_Display === 'Y') {
      return (
        <div className="col-md-6">
          <div className="form-group row">
            <label className="col-md-6 mt-1">Jumlah Display</label>
            <input type="text" className="form-control col-md-6" autoComplete="off" name="Attachment_Jml_Display" value={this.state.Attachment_Jml_Display} onChange={this.handleChangeInput.bind(this)} />
          </div>
        </div>
      )
    }
  }

  renderAdditionalData = () => {
    if (this.state.Attachment_Data === 'Y') {
      return (
        <div className="col-md-6">
          <div className="form-group row">
            <label className="col-md-6 mt-1">Jumlah Data</label>
            <input type="text" className="form-control col-md-6" autoComplete="off" name="Attachment_Jml_Data" value={this.state.Attachment_Jml_Data} onChange={this.handleChangeInput.bind(this)} />
          </div>
        </div>
      )
    }
  }

  renderAttachment = () => {
    return (
      <div className="card">
        <div className="card-header font-size-title bg-light">
          Attachment
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              {this.renderDocumentV2()}
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-md-6">
              {this.renderJumlahDisplay()}
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-md-6">
              {this.renderUploadSingle('REQUIRED')}
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderButton = () => {
    return (
      <div className="row">
        <div className="col-md-3">
          <button type="button" className="btn btn-primary btn-block" onClick={this.handleSubmit.bind(this)}><i className="fa fa-save" /> Submit</button>
        </div>
        <div className="col-md-3">
          <button type="button" className="btn btn-warning btn-block" onClick={() => { this.props.history.push('/admin/claim-chd/reject') }}><i className="fa fa-arrow-left" /> Back</button>
        </div>
      </div>
    )
  }

  formValidation = () => {
    let { error } = this.state
    error = []

    if (this.state.Claim_Period_Type === "") {
      error.push('Claim Period Type is required, ex: Monthly / Quarterly')
    }
    if (this.state.Claim_Period_Year === "") {
      error.push('Select Year of Period')
    }
    if (this.state.Claim_Period_Month === "") {
      error.push('Select Month / Quarter')
    }
    // if (this.state.Claim_Activity === "") {
    //   error.push('Claim activity is required')
    // }
    if (this.state.Claim_CostCenter === "") {
      error.push('Claim cost center is required')
    }
    // if (this.state.Claim_CustomerReceipt === "") {
    //   error.push('Claim customer receipt is required')
    // }
    if (this.state.Claim_DPP === "" || this.state.Claim_DPP === '0') {
      error.push('Claim DPP is required')
    }

    if((!this.state.Claim_PPh_Type && !this.state.Claim_Old_PPh_type)){
      error.push("PPh Type is required")
    }
    // if (this.state.Claim_TaxDate === "") {
    //   error.push('Claim tax date is required')
    // }
    // if (this.state.Claim_TaxNo === "" || this.state.Claim_TaxNo.length === 0) {
    //   error.push('Claim tax no is required')
    // } else {
    //   let count = this.state.Claim_TaxNo.replace(/\.|-/g, "");
    //   if (count.length < 16 || count.length > 16) {
    //     error.push("Invalid Tax No, must be contain 16 digits (exclude . & -)");
    //   }
    // }
    if (this.state.Claim_SKB === "Y") {
      if (!this.state.fileSKB.filename) {
        error.push("Please attach document for exemption certificate");
      }
      if (this.state.Claim_SKBNumber === "") {
        error.push("SKB Number is empty");
      }
    }

    if (this.state.Attachment_Display === 'Y') {
      if (this.state.Attachment_Jml_Display === '' || this.state.Attachment_Jml_Display === '0') {
        error.push('Jumlah display is required')
      }
    }

    if (this.state.Document_Selected.length < this.state.Document_List.length) {
      error.push('Please complete the required attachments')
    } else {
      if (this.state.fileRequired.path.length === 0) {
        error.push('Upload the required attachment')
      }
    }

    // Nett must be higher than 10K
    if (parseInt(this.removeSeparator(this.state.Claim_Nett) || 0) < 10000) {
      error.push("Claim Nett must be more than equal to 10,000")
    }

    if (error.length > 0) {
      window.scrollTo(0, 0);
      this.setState({ error: error });
      return false;
    } else {
      return true;
    }
  }
  handleSubmit = () => {
    if (this.formValidation()) {
      let url = '/api/traces_chd/v1/claim/update'
      let { id } = this.props.match.params;
      let param = {
        claim_id: id,
        program_customer_id: this.state.Program_Customer_ID,
        dpp: this.removeSeparator(this.state.Claim_DPP),
        ppn: this.removeSeparator(this.state.Claim_PPn),
        pph: this.removeSeparator(this.state.Claim_PPh),
        pph_type: this.state.Claim_PPh_Type && this.state.Claim_PPh_Type.length > 0 ? this.state.Claim_PPh_Type : null,
        pph_rate: this.state.Claim_PPhRate,
        total: this.removeSeparator(this.state.Claim_TotalAmount),
        payment_method: this.state.Claim_PaymentMethod,
        bank_name: this.state.Customer_BankName,
        bank_account_no: this.state.Customer_BankAccountNo,
        bank_account_owner: this.state.Customer_BankAccountOwner,
        npwp: this.state.Customer_NPWP,
        npwp_name: this.state.Customer_NPWPName,
        npwp_address: this.state.Customer_NPWPAddress,
        skb: this.state.Claim_SKB,
        skb_number: this.state.Claim_SKBNumber,
        fileSKB: this.state.fileSKB,
        tax_no: this.state.Claim_TaxNo,
        tax_date: this.state.Claim_TaxDate,
        fileRequired: this.state.fileRequired,
        user_id: this.state.user.user_id,
        org_initial: this.state.General_PrincipalCode,
        // branch_code: this.state.user.org_name,
        branch_code: this.state.General_Branch_Code,
        jml_display: this.state.Attachment_Jml_Display,
        receipt_no: this.state.Claim_CustomerReceipt,
        activity_id: this.state.Claim_Activity,
        ccid: this.state.Claim_CostCenter,
        additional_data: this.state.Attachment_Jml_Data,
        skb_start_date: this.state.Claim_SKB_Start_Date,
        skb_end_date: this.state.Claim_SKB_End_Date,
        bukpot: this.state.Claim_Bukpot,
        nett: this.removeSeparator(this.state.Claim_Nett),
        program_start: this.state.General_StartDate,
        program_end: this.state.General_EndDate,
        package: this.state.Claim_Package,
        program_name: this.state.General_ProgramType,
        customer_id: this.state.Customer_Id,
        customer_name: this.state.Customer_Name,
        // branch: this.state.user.org_name,
        branch: this.state.General_Branch_Code,
        claim_number: this.state.Claim_ClaimNumber,
        period_type: this.state.Claim_Period_Type,
        period_year: this.state.Claim_Period_Year,
        period_selected_num: this.state.Claim_Period_Month,
        requester: this.state.user.username || '',
        email: this.state.user.username || '',
        pkp_badan: this.state.Customer_PKP_Badan || 'N',
        potong_pajak: this.state.Customer_Potong_Pajak || 'N',
        rejected_by: this.state.Claim_Rejected_By,
        skp_number: this.state.General_SkpNumber,
        status: 'R'
      }

      this.setState({ loading: true })
      request.postCHD(url, param, {
        success: function (response) {
          let msg = response.data.message || 'Claim berhasil disubmit'
          this.setState({
            loading: false,
            success: msg
          })
          window.scrollTo(0, 0)

          let app = this
          window.setTimeout(() => {
            app.props.history.push('/admin/claim-chd/reject')
          }, 3000)
        }.bind(this),
        error: function (e) {
          window.scrollTo(0, 0)
          this.setState({ loading: false, error: ['Failed to reject claim, please try again'] })
        }.bind(this)
      })
    }
  }

  renderReason = () => {
    return (
      <div className="row mb-3">
        <div className="col-md-6">
          <div className="form-group">
            <label className="">Reason:</label>
            <textarea className="form-control" value={this.state.Claim_Reason_Reject} rows={5} disabled={true}></textarea>
          </div>
        </div>
        <div className="col-md-6 pt-4">
          <label><small><i>Last update by: {this.state.Updated_By}</i></small></label>
        </div>
      </div>
    )
  }

  handleDetailInsentif = (pdf) => {
    let error = []
    if (this.state.Claim_Period_Year === "") {
      error.push('Select Year of Period')
    }
    if (this.state.Claim_Period_Type === "") {
      error.push('Claim Period Type is required, ex: Monthly / Quarterly')
    }
    if (this.state.Claim_Period_Month === "") {
      error.push('Select Month / Quarter')
    }
    if (error.length > 0) {
      window.scrollTo(0,0)
      this.setState({ error: error })
      return false
    }

    let url = '/api/traces_chd/v1/claim/detail-insentif'
    let param = {
      customer_name: this.state.Customer_Name,
      customer_id: this.state.Customer_Id,
      program_name: this.state.General_ProgramType,
      package: this.state.Claim_Package,
      branch: this.state.General_Branch_Code,
      program_start: this.state.General_StartDate,
      program_end: this.state.General_EndDate,
      period_type: this.state.Claim_Period_Type,
      period_selected_num: this.state.Claim_Period_Month,
      period_year: this.state.Claim_Period_Year,
      rejected_by: this.state.Claim_Rejected_By
    }
    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function (response) {
        let { data } = response.data
        this.setState({ loading: false })
        if (data.fullpath && pdf) {
          window.open(data.fullpath, '_blank')
        }
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false })
      }.bind(this)
    })
  }

  renderInputDPP = () => {
    let { Claim_Source_DWH } = this.state
    if (Claim_Source_DWH === 'Y') {
      return (
        <div className="input-group col-md-8 p-0">
          <input type="text" autoComplete="off" disabled={this.state.Claim_Source_DWH === 'Y' ? true : false} className="form-control" name="Claim_DPP" value={this.state.Claim_DPP} onChange={this.handleChangeInput.bind(this)} />
          {/* <button type="button" className="btn btn-info col-md-3">View Docs</button> */}
          {/* <div className="input-group-append">
            <button className="btn btn-primary" onClick={this.handleDetailInsentif.bind(this)} type="button">View Docs</button>
          </div> */}
        </div>
      )
    } else {
      return (
        <input
          type="text"
          autoComplete="off"
          disabled
          className="form-control col-md-8"
          name="Claim_DPP"
          value={this.state.Claim_DPP}
          onChange={this.handleChangeInput.bind(this)}
        />
        // <div className="input-group col-md-8 p-0">
        //   <input type="text" autoComplete="off" disabled={this.state.Claim_Source_DWH === 'Y' ? true : false} className="form-control col-md-8" name="Claim_DPP" value={this.state.Claim_DPP} onChange={this.handleChangeInput.bind(this)} />
        //   <div className="input-group-append">
        //     <button className="btn btn-primary" onClick={this.calculateTotalClaim.bind(this)} type="button"><i className="fa fa-calculator" /> Calculate</button>
        //   </div>
        // </div>
      )
    }
  }

  calculateTotalClaim = () => {
    let error = []
    if (this.state.Claim_Period_Year === "") {
      error.push('Select Year of Period')
    }
    if (this.state.Claim_Period_Type === "") {
      error.push('Claim Period Type is required, ex: Monthly / Quarterly')
    }
    if (this.state.Claim_Period_Month === "") {
      error.push('Select Month / Quarter')
    }
    if (error.length > 0) {
      window.scrollTo(0,0)
      this.setState({ error: error })
      return false
    }

    let url = '/api/traces_chd/v1/claim/data-insentif'
    let param = {
      source_dwh: this.state.Claim_Source_DWH || 'N',
      period_month: this.state.Claim_Period_Month || '',
      period_year: this.state.Claim_Period_Year || '',
      customer_id: this.state.Customer_Id,
      program_name: this.state.General_ProgramType || '',
      package: this.state.Claim_Package || '',
      pkp_badan: this.state.Customer_PKP_Badan || 'N',
      potong_pajak: this.state.Customer_Potong_Pajak || 'N',
      skb: this.state.Claim_SKB || 'N',
      skb_start: this.state.Claim_SKB_Start_Date || '',
      skb_end: this.state.Claim_SKB_End_Date || '',
      dpp: this.removeSeparator(this.state.Claim_DPP || 0),
      period_type: this.state.Claim_Period_Type,
      pph_rate: this.state.Claim_PPhRate,
      pph_type: this.state.Claim_PPh_Type,
      rejected_by: this.state.Claim_Rejected_By,
      skp_number: this.state.General_SkpNumber || ''
    }

    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function (response) {
        let { data } = response.data
        let dpp = this.state.Claim_Source_DWH === 'Y' || this.state.General_ProgramType == 'BRANDING RELASI' ? data.reward.TOTAL_REWARD : this.state.Claim_DPP
        console.log('DPP', dpp)
        console.log('SOURCE', this.state.Claim_Source_DWH)
        this.setState({
          loading: false,
          Claim_PPn: this.thousandSeparator(data.claim.ppn || '0'),
          Claim_DPP: this.thousandSeparator(dpp || '0'),
          Claim_PPhRate: data.claim.pph_rate,
          Claim_PPh: this.thousandSeparator(data.claim.pph || '0'),
          Claim_PPh_Type: data.claim.pph_type,
          Claim_TotalAmount: this.thousandSeparator(data.claim.total_claim || '0'),
          Claim_Bukpot: data.claim.bukpot,
          Claim_Nett: this.thousandSeparator(data.claim.nett || 0)
        })
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false })
      }.bind(this)
    })
  }
  
  renderPeriod = () => {
    let { Claim_Source_DWH } = this.state
    if (Claim_Source_DWH === 'Y') {
      return (
        <div className="col-md-12">
          <h5>Period</h5>
          <div className="form-group row">
            <div className="col-md-4">
              {this.renderYear()}
            </div>
            <div className="col-md-4">
              {this.renderLovPeriod()}
            </div>
            <div className="col-md-4">
              {this.renderMonth()}
            </div>
          </div>
        </div>
      )
    }
  }

  renderYear = () => {
    let thisYear = moment(new Date()).format('YYYY')
    let arrayYear = [thisYear, thisYear - 1]
    return (
      <select disabled className="form-control" name="Claim_Period_Year" onChange={this.handleChangeInput.bind(this)} value={this.state.Claim_Period_Year}>
        <option value="">- Select Year -</option>
        {
          arrayYear.map((item, index) => (
            <option key={index} value={item}>{item}</option>
          ))
        }
      </select>
    )
  }

  renderLovPeriod = () => {
    let arrayPeriod = [
      {
        text: 'Monthly',
        value: 'M'
      },
      {
        text: 'Quarterly',
        value: 'Q'
      }
    ]
    return (
      <select disabled className="form-control" name="Claim_Period_Type" onChange={this.handleChangeInput.bind(this)} value={this.state.Claim_Period_Type}>
        <option value="">- Select Period -</option>
        {
          arrayPeriod.map((item, index) => (
            <option key={index} value={item.value}>{item.text}</option>
          ))
        }
      </select>
    )
  }

  renderMonth = () => {
    let {Claim_Period_Type} = this.state

    let arrayMonth = []
    if (Claim_Period_Type === 'M') {
      arrayMonth = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      return (
        <select disabled className="form-control" name="Claim_Period_Month" onChange={this.handleChangeInput.bind(this)} value={this.state.Claim_Period_Month}>
          <option value="">- Select Month -</option>
          {
            arrayMonth.map((item, index) => (
              <option key={index} value={index + 1}>{item}</option>
            ))
          }
        </select>
      )
    } else if (Claim_Period_Type === 'Q') {
      arrayMonth = [1, 2, 3, 4]
      return (
        <select disabled className="form-control" name="Claim_Period_Month" onChange={this.handleChangeInput.bind(this)} value={this.state.Claim_Period_Month}>
          <option value="">- Select Month -</option>
          {
            arrayMonth.map((item, index) => (
              <option key={index} value={item}>{item}</option>
            ))
          }
        </select>
      )
    }    
  }

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <form className="form-horizontal">
                  <div className="card card-info">
                    <div className="card-body">
                      {this.renderGeneralInfo()}
                      {this.renderProduct()}
                      {this.renderCustomerInfo()}
                      {this.renderClaimInfo()}
                      {/* {this.renderAttachment()} */}
                      {this.renderReason()}
                      {this.renderButton()}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    )
  }
}

export default ClaimDetailCHD